import { Directive, OnChanges, Input, SimpleChanges } from '@angular/core';
import { NgControl, FormControl } from '@angular/forms';

@Directive({
  selector: '[appUncheck]'
})
export class UncheckDirective implements OnChanges {


  @Input('appUncheck')
  unchek: boolean;

  input: NgControl;

  constructor(private ngControl: NgControl) {
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.unchek.currentValue) {
      // TODO: Estudar o angular Life Cycle e remover esse setTimeout
      // Atualmente estamos usando pois essa diretiva entra em conflito com a [appCheck]
      setTimeout(() => {
        (this.ngControl.control as FormControl).setValue(false);
      }, 0);


    }
  }


}
